module.exports = __webpack_public_path__ + "img/wieza.d6cb1000.jpg";